import React from 'react'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import { Button } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme) => ({
    main: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        justifyContent: 'flex-start',
        height: 'calc(100vh - 60px)',
    },
}))

const StudentProfile = ({ onGoBakToCapeeshApp }) => {
    const classes = useStyles()

    return (
        <div className={classes.main}>
            <div style={{ display: 'flex', alignItems: 'left', paddingLeft: '16px', paddingTop: '16px' }}>
                <Button
                    style={{ width: '250px', height: '40px', textTransform: 'none' }}
                    variant={'contained'}
                    onClick={onGoBakToCapeeshApp}>
                    <ArrowBackIcon width={25} height={25} style={{ paddingRight: '8px' }} />
                    <FormattedMessage
                        id={'student.back.to.capeesh.app'}
                        defaultMessage={'Back to {appName}'}
                        values={{ appName: 'Capeesh App' }}
                    />
                </Button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>student profile here</div>
        </div>
    )
}

StudentProfile.propTypes = {}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentProfile)
